"use client";

import clsx from "clsx";
import { Link } from "@repo/next-utils/router";
import { useBag } from "@repo/ui/bag";
import { Button } from "@repo/ui/button";
import { VisuallyHidden } from "@repo/ui/visually-hidden";
import { BagIcon } from "@/theme/icons/bag";
import styles from "./nav.module.css";

export type BagCounterProps = {
  className?: string;
};

export const BagCounter = ({ className }: BagCounterProps) => {
  const { customerHasBag, getItemCount } = useBag();
  const total = customerHasBag && getItemCount()?.total;
  const showCount = !!total;
  const hasExceededMaxCount = total && total > 99;

  return (
    <Button size="icon" asChild>
      <Link href="/bag" className={styles.badgeContainer}>
        <BagIcon
          filled={showCount}
          className={className}
          label="View your bag."
        />
        {showCount && (
          <span
            className={clsx(
              className,
              styles.badge,
              hasExceededMaxCount && styles.maxCount,
            )}
          >
            {hasExceededMaxCount ? "99+" : total}
            <VisuallyHidden>
              {total === 1 ? "item in your bag" : "items in your bag"}
            </VisuallyHidden>
          </span>
        )}
      </Link>
    </Button>
  );
};
